import type { AnalyticsUser } from 'src/pages/AnalyticsPage/AnalyticsAgent/analyticsAgent.types';

export const AnalyticsUsersList = ({ userList }: { userList: AnalyticsUser[] }) => {
  return (
    <div className={'flex flex-row flex-1 gap-4 flex-wrap'}>
      {userList.map((user) => {
        return (
          <div key={user.key} className={'flex flex-row items-center gap-1'}>
            <div className={'rounded-[50%] w-2.5 h-2.5'} style={{ background: user.color }}></div>
            <span className={'text-xs font-medium'}>{user.full_name}</span>
          </div>
        );
      })}
    </div>
  );
};
